import * as service from './service'
import { HTTP_CODE } from '@/utils/request'

export default {
  namespace: 'valueHome',
  state: {
    demoData: {}
  },
  effects: {
    * getDataInfo ({ payload }, { call, put }) {
      const res = yield call(service.getDataInfo, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data
    },
    * firstWatch ({ payload }, { call, put }) {
      const res = yield call(service.firstWatch, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data.data
    },
    * status ({ payload }, { call, put }) {
      const res = yield call(service.status, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
